// extracted by mini-css-extract-plugin
export default {"pageTitle":"date_pageTitle__MnhPX","date":"date_date__jo-Y5"};